export class APIResponse {

  properties: {} = {};

  getCode(): number {
    return this.properties['code'];
  }

  getDescription(): string {
    return this.properties['description'];
  }

  hasSchema(): boolean {
    return this.properties['schema'] != undefined;
  }

  isArray(): boolean {
    return this.properties['schema']['type'] == 'array';
  }

  getSchema(): {} {
    return this.properties['schema'];
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/components/core/model/api-response.ts
 **/